import DeviceTypeClientListingModel from '@shared/models/devices/DeviceTypeClientListingModel';
import OrganizationAuthClientModel from '@shared/models/organizations/OrganizationAuthClientModel';
import OrganizationDeviceTypeModel from '@shared/models/organizations/OrganizationDeviceTypeModel';
import { locales } from '../localization/LocalizationConstants';

export const DefaultDeviceType: OrganizationDeviceTypeModel = {
    createdDate: '',
    modifiedDate: '',
    name: '',
    description: '',
    isPrivate: false,
    isSupported: false,
    isVirtual: false,
    defaultLocale: '',
    supportsVoiceInput: false,
    supportsFaceInput: false,
    supportsGestureInput: false,
    supportsPhysicalInput: false,
    supportsWifi: false,
    supportsDigitalExtensions: false,
    supportsPhysicalExtensions: false,
    supportsKeyboardOutput: false,
    supportsGenericControllerOutput: false,
    supportsXboxControllerOutput: false,
    supportsPlayStationControllerOutput: false,
    supportsNintendoControllerOutput: false,
    supportsTextGeneration: false,
    supportsTextSummarization: false,
    supportsNLUCommands: false,
    supportsEnhancedDictation: false,
    supportsAIWorkflows: false,
    supportsAutoProfileSwitching: false,
    isApplication: true,
};

export const DefaultClient: OrganizationAuthClientModel = {
    organizationId: '',
    name: '',
    originHost: '',
    createdDate: new Date().toISOString(),
    modifiedDate: new Date().toISOString(),
    tokenAdditionalRedirectUris: [],
    additionalRedirectUris: [],
    authClientScopes: [],
    authClientDeviceTypes: [],
};

export const DefaultClientListing: DeviceTypeClientListingModel[] = locales.display.map((locale) => ({
    deviceTypeId: '',
    locale: locale,
    title: '',
    shortDescription: '',
    markdownDescription: '',
    markdownOnboardingInstructions: '',
    markdownTroubleshootingInstructions: '',
    iconUrl: '',
    darkModeIconUrl: '',
    createdDate: '',
    updatedDate: '',
    priority: 0,
    isPublic: false,
}));
